import { Link } from "react-router-dom";

import { Sensitive } from "@/components/common/Sensitive";
import { formatContractRef } from "@/lib/formatContract";
import { ratesFilterHref } from "@/lib/ratesFilterLink";
import { cn } from "@/lib/utils";

interface ContractLinkProps {
  contractRef?: string | null;
  namedAccount?: string | null;
  carrier?: string | null;
  /** Kept for callers; navigation always applies rates-list filters. */
  rateCardId?: string | null;
  className?: string;
}

/**
 * Contract token that opens the rates list filtered to this contract,
 * including expired / superseded cards so historical refs are visible.
 */
export function ContractLink({
  contractRef,
  namedAccount,
  carrier,
  className,
}: ContractLinkProps) {
  const ref = contractRef?.trim() ?? "";
  const label = formatContractRef(ref, namedAccount, carrier);

  if (!ref || !label) {
    return <span className={className}>—</span>;
  }

  const href = ratesFilterHref({
    contract_ref: ref,
    carrier,
    include_inactive: true,
  });

  return (
    <Link
      to={href}
      className={cn(
        "text-foreground underline-offset-2 hover:underline",
        className,
      )}
    >
      <Sensitive>{label}</Sensitive>
    </Link>
  );
}
